(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["p4h-academia"] && !Shopify.designMode) return;
  try {
    
function p4hAcademiaInit(){

(function(){
 'use strict';
 const root=document.getElementById('p4h-gateway');
 const loader=root.querySelector('.ph-platform-loader');
 if(!root||!loader||root.dataset.platformInit==='true')return;
 root.dataset.platformInit='true';
 const started=Date.now();
 let finished=false,hideTimer=0,finishTimer=0;
 loader.hidden=false;
 function dismiss(immediate){
  if(finished){if(immediate)loader.hidden=true;return;}
  finished=true;
  clearTimeout(safetyTimer);
  clearTimeout(finishTimer);
  if(immediate){loader.hidden=true;return;}
  loader.dataset.exiting='true';
  hideTimer=setTimeout(()=>{loader.hidden=true;},220);
 }
 const safetyTimer=setTimeout(()=>dismiss(true),8000);
 function ready(){
  if(finished)return;
  finishTimer=setTimeout(()=>{requestAnimationFrame(()=>requestAnimationFrame(()=>dismiss(false)));},Math.max(0,300-(Date.now()-started)));
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});
 else ready();
 window.addEventListener('pageshow',event=>{if(event.persisted){clearTimeout(hideTimer);dismiss(true);}});
})();


(function(){
 'use strict';
 const root=document.getElementById('p4h-gateway');
 if(!root||root.dataset.universalFeedback==='true')return;
 root.dataset.universalFeedback='true';
 let status=root.querySelector('#ph-course-navigation-status')||root.querySelector('#ph-universal-feedback-status');
 if(!status){
  status=document.createElement('p');
  status.id='ph-universal-feedback-status';
  status.className='ph-course-status';
  status.setAttribute('role','status');
  status.setAttribute('aria-live','polite');
  status.setAttribute('aria-atomic','true');
  root.appendChild(status);
 }
 let pending=null,statusOwner=null;
 const brief=new Map();
 const read=(el,name)=>el.getAttribute(name);
 function restore(el,name,value){if(value===null)el.removeAttribute(name);else el.setAttribute(name,value);}
 function announce(message,owner,visible){
  statusOwner=owner;
  status.textContent=message;
  if(visible)status.setAttribute('data-visible','true');else status.removeAttribute('data-visible');
 }
 function clearAnnouncement(owner){
  if(statusOwner!==owner)return;
  statusOwner=null;status.textContent='';status.removeAttribute('data-visible');
 }
 function mark(control,kind){
  const saved={control,feedback:read(control,'data-ph-feedback'),host:read(control,'data-ph-feedback-host'),busy:read(control,'aria-busy')};
  const position=window.getComputedStyle?window.getComputedStyle(control).position:'';
  if(position==='static')control.setAttribute('data-ph-feedback-host','');
  control.setAttribute('data-ph-feedback',kind);
  control.setAttribute('aria-busy','true');
  return saved;
 }
 function unmark(saved){
  restore(saved.control,'data-ph-feedback',saved.feedback);
  restore(saved.control,'data-ph-feedback-host',saved.host);
  restore(saved.control,'aria-busy',saved.busy);
 }
 function cancelBrief(control){
  const state=brief.get(control);
  if(!state)return;
  clearTimeout(state.timer);unmark(state.visual);brief.delete(control);clearAnnouncement(state);
 }

 function temporaryText(container,value){
  const nodes=[];
  function collect(node){
   Array.from(node.childNodes||[]).forEach(child=>{
    if(child.nodeType===3)nodes.push({node:child,value:child.nodeValue});
    else if(child.nodeType===1&&!/^(svg|script|style)$/i.test(child.tagName||''))collect(child);
   });
  }
  collect(container);
  let chosen=nodes.find(item=>item.node.parentNode===container&&item.value.trim())||nodes.find(item=>item.value.trim());
  let added=null;
  if(!chosen){added=document.createTextNode(value);container.appendChild(added);}
  nodes.forEach(item=>{item.node.nodeValue=item===chosen?value:'';});
  return ()=>{nodes.forEach(item=>{item.node.nodeValue=item.value;});if(added&&added.parentNode)added.parentNode.removeChild(added);};
 }
 function courseFeedback(control){
  if(!control.matches('.ph-course-main,.ph-course-open'))return null;
  const card=control.closest('.ph-course');
  const more=card&&card.querySelector('.ph-course-more');
  const label=card&&card.querySelector('.ph-open-label');
  if(!card||!more||!label)return null;
  const hadClass=card.classList.contains('is-loading'),busy=read(card,'aria-busy');
  const restoreMore=temporaryText(more,'Abriendo temario…');
  const restoreLabel=temporaryText(label,'Abriendo…');
  const spinner=document.createElement('span');spinner.className='ph-spinner';spinner.setAttribute('aria-hidden','true');
  more.insertBefore(spinner,more.firstChild);
  card.classList.add('is-loading');card.setAttribute('aria-busy','true');
  const title=card.querySelector('h3');
  return {title:title?title.textContent.trim():'este curso',clear(){
   restoreMore();restoreLabel();if(spinner.parentNode)spinner.parentNode.removeChild(spinner);
   if(!hadClass)card.classList.remove('is-loading');restore(card,'aria-busy',busy);
  }};
 }
 function clearPending(){
  if(!pending)return;
  const state=pending;pending=null;
  clearTimeout(state.timer);if(state.course)state.course.clear();unmark(state.visual);clearAnnouncement(state);
 }
 function resetAll(){
  clearPending();Array.from(brief.keys()).forEach(cancelBrief);
  statusOwner=null;status.textContent='';status.removeAttribute('data-visible');
 }
 function shortFeedback(control,duration,message){
  if(pending&&pending.control===control)clearPending();
  cancelBrief(control);
  const state={visual:mark(control,'generic'),timer:0};
  brief.set(control,state);
  if(message)announce(message,state,false);
  else if(status.hasAttribute('data-visible'))clearAnnouncement(statusOwner);
  state.timer=setTimeout(()=>{if(brief.get(control)===state)cancelBrief(control);},duration);
 }
 function classify(control){
  if(control.tagName.toLowerCase()!=='a')return {kind:'immediate'};
  const raw=(read(control,'href')||'').trim();
  if(!raw||raw.charAt(0)==='#')return {kind:'immediate'};
  let url;
  try{url=new URL(raw,document.baseURI||window.location.href);}catch(_){return {kind:'brief',message:'Solicitando apertura del enlace.'};}
  const target=(read(control,'target')||'').toLowerCase();
  if(control.hasAttribute('download'))return {kind:'brief',message:'Solicitando la descarga.'};
  if(url.protocol==='mailto:')return {kind:'brief',message:'Solicitando apertura del correo.'};
  if(url.protocol==='tel:')return {kind:'brief',message:'Solicitando apertura de llamada.'};
  if(url.hostname==='wa.me'||/(^|\.)whatsapp\.com$/i.test(url.hostname)||url.protocol==='whatsapp:')return {kind:'brief',message:'Solicitando apertura de WhatsApp.'};
  if(url.protocol==='javascript:')return {kind:'immediate'};
  if(!/^https?:$/.test(url.protocol)||target&&!['_self','_top','_parent'].includes(target))return {kind:'brief',message:'Solicitando apertura del enlace.'};
  try{
   const current=new URL(document.baseURI||window.location.href);
   if(url.hash&&url.origin===current.origin&&url.pathname===current.pathname&&url.search===current.search)return {kind:'immediate'};
  }catch(_){}
  return {kind:'navigation',key:url.href+'|'+(target||'_self')};
 }
 root.addEventListener('click',event=>{

  if(typeof event.button==='number'&&event.button!==0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
  let target=event.target;if(target&&target.nodeType===3)target=target.parentElement;
  const control=target&&target.closest?target.closest('a[href],button,summary'):null;
  if(!control||!root.contains(control)||control.disabled||control.matches(':disabled')||control.closest('[inert],[aria-disabled="true"]'))return;
  const action=classify(control);

  if(action.kind==='immediate'){
   shortFeedback(control,650,'');return;
  }

  if(event.defaultPrevented){shortFeedback(control,650,'');return;}
  if(action.kind==='brief'){
   shortFeedback(control,1200,action.message);return;
  }
  if(pending&&pending.key===action.key){event.preventDefault();return;}
  clearPending();cancelBrief(control);
  const course=courseFeedback(control);
  const state={control,key:action.key,course,visual:mark(control,course?'course':'generic'),timer:0};
  pending=state;
  const label=(read(control,'aria-label')||control.textContent||'el enlace').replace(/\s+/g,' ').trim().slice(0,120);
  announce(course?'Abriendo el temario de '+course.title+'.':'Abriendo '+label+'.',state,false);
  state.timer=setTimeout(()=>{
   if(pending!==state)return;
   clearPending();
   announce('La página está tardando en abrir. Puedes volver a pulsar el enlace para reintentar.',{},true);
  },15000);

 });
 window.addEventListener('pagehide',resetAll);
 window.addEventListener('pageshow',resetAll);
})();



(function(){
'use strict';
const root=document.getElementById('p4h-gateway');if(!root||root.dataset.motionInit)return;root.dataset.motionInit='true';
const videos=Array.from(root.querySelectorAll('.ph-video')),toggle=root.querySelector('.ph-motion'),loader=root.querySelector('.ph-platform-loader'),reduced=matchMedia('(prefers-reduced-motion:reduce)');
let paused=reduced.matches,visible=true,ready=false,cycle=0;
toggle.hidden=false;
function syncButton(){root.dataset.motion=paused?'paused':'playing';toggle.dataset.paused=String(paused);toggle.setAttribute('aria-pressed',String(paused));const label=paused?'Reproducir animaciones':'Pausar animaciones';toggle.setAttribute('aria-label',label);toggle.title=label;}
function update(){const current=++cycle;syncButton();if(paused||document.hidden||!visible||!ready){videos.forEach(v=>v.pause());return;}Promise.all(videos.map(v=>{if(!v.hasAttribute('src'))v.src=v.dataset.src;v.muted=true;return Promise.resolve(v.play()).then(()=>true,()=>false);})).then(results=>{if(current===cycle&&!results.some(Boolean)){paused=true;syncButton();}});}
toggle.addEventListener('click',()=>{paused=!paused;update();});
reduced.addEventListener('change',e=>{paused=e.matches;update();});
document.addEventListener('visibilitychange',update);window.addEventListener('pagehide',()=>videos.forEach(v=>v.pause()));window.addEventListener('pageshow',update);
if('IntersectionObserver' in window){const io=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;update();},{threshold:0.05});io.observe(root.querySelector('.ph-stage'));}
function loaderDone(){if(!loader||loader.hidden||getComputedStyle(loader).visibility==='hidden'){ready=true;update();return true;}return false;}
if(!loaderDone()&&loader){const mo=new MutationObserver(()=>{if(loaderDone())mo.disconnect();});mo.observe(loader,{attributes:true,attributeFilter:['hidden']});loader.addEventListener('animationend',()=>{ready=true;update();},{once:true});setTimeout(()=>{if(loaderDone())mo.disconnect();},9200);}
syncButton();
})();

}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',p4hAcademiaInit,{once:true});}else{p4hAcademiaInit();}
document.addEventListener('shopify:section:load',p4hAcademiaInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p4h-homepage-v1"] && !Shopify.designMode) return;
  try {
    
(function(w,d){
  'use strict';
  if(w.P4HAttribution&&w.P4HAttribution.version===2){w.P4HAttribution.refresh();return;}
  const KEY='p4h-subscription-attribution-v1';
  const KEYS=['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id','placement','fbclid','gclid'];
  const CLICKS=['fbclid','gclid'];
  const HOSTS=['www.p4hbionics.academy','p4hbionics.academy'];
  const originals=new WeakMap();
  let saved={},lastSignature='';
  function clean(input){
    const result={};
    if(input&&typeof input==='object')KEYS.forEach(key=>{
      const value=input[key];
      if(typeof value==='string'&&value.trim()&&value.length<=4096&&!/[\u0000-\u001f\u007f]/.test(value))result[key]=value;
    });
    return result;
  }
  try{const record=JSON.parse(w.sessionStorage.getItem(KEY)||'null');if(record&&(record.version===1||record.version===2))saved=clean(record.params);}catch(error){}
  function persist(){try{w.sessionStorage.setItem(KEY,JSON.stringify({version:2,params:saved}));}catch(error){}}
  function facebookCookie(){
    let raw;try{raw=d.cookie||'';}catch(error){return null;}
    let latest=null;
    raw.split(';').forEach(entry=>{
      const separator=entry.indexOf('=');
      if(separator<0||entry.slice(0,separator).trim()!=='_fbc')return;
      let value;try{value=decodeURIComponent(entry.slice(separator+1).trim());}catch(error){return;}
      const parts=value.split('.');
      if((parts.length!==4&&parts.length!==5)||parts[0]!=='fb'||!/^\d+$/.test(parts[1])||!/^\d+$/.test(parts[2])||!/[A-Za-z0-9_-]/.test(parts[3])||!/^[A-Za-z0-9_-]+$/.test(parts[3])||
        (parts.length===5&&!['AQ','Ag','Aw','BA','BQ','Bg'].includes(parts[4])&&!/^[A-Za-z0-9_-]{8}$/.test(parts[4])))return;
      const created=Number(parts[2]);
      if(!Number.isSafeInteger(created)||created<=0)return;
      if(!latest||created>latest.created)latest={created:created,clickId:parts[3],fullValue:value};
    });
    return latest;
  }
  function current(){
    const query=new URLSearchParams(w.location.search),input={};
    KEYS.forEach(key=>{if(query.has(key))input[key]=query.get(key);});
    const incoming=clean(input),names=Object.keys(incoming),signature=JSON.stringify(incoming);
    if(names.length&&signature!==lastSignature){
      const clicks=CLICKS.filter(key=>incoming[key]);
      const sameClick=clicks.length>0&&clicks.every(key=>incoming[key]===saved[key]);
      const sameCampaign=!clicks.length&&names.every(key=>incoming[key]===saved[key]);
      saved=(sameClick||sameCampaign)?Object.assign({},saved,incoming):incoming;
      lastSignature=signature;persist();
    }
    const params=Object.assign({},saved);
    // Cookie recovery is only for an otherwise unattributed visit. Never attach
    // a previous Meta click to a new Google/email/UTM-only campaign.
    if(!Object.keys(params).length){const cookie=facebookCookie();if(cookie)params.fbclid=cookie.clickId;}
    return params;
  }
  function allowed(url){
    return url.protocol==='https:'&&(HOSTS.includes(url.hostname.toLowerCase())||
      (url.hostname.toLowerCase()==='checkout.teachable.com'&&/^\/secure\/189930\/checkout\//.test(url.pathname)));
  }
  function decorate(input){
    const url=new URL(input,w.location.href);
    if(!allowed(url))return url.href;
    const params=current();
    if(Object.keys(params).length){KEYS.forEach(key=>url.searchParams.delete(key));KEYS.forEach(key=>{if(params[key])url.searchParams.set(key,params[key]);});}
    return url.href;
  }
  function refreshLink(link){
    if(!link||!link.getAttribute||link.hasAttribute('download'))return;
    const rendered=link.getAttribute('href')||'';
    const previous=originals.get(link);
    const raw=previous&&rendered===previous.rendered?previous.original:rendered;
    if(!raw||raw.trim().startsWith('#'))return;
    let url;try{url=new URL(raw,w.location.href);}catch(error){return;}
    if(!allowed(url))return;
    // Preserve full-URL anchors on this page as ordinary in-page navigation.
    if(url.origin===w.location.origin&&url.pathname===w.location.pathname&&url.search===w.location.search&&url.hash)return;
    const next=decorate(url);
    if(next!==rendered)link.setAttribute('href',next);
    originals.set(link,{original:raw,rendered:next});
  }
  function refresh(){current();d.querySelectorAll('a[href]').forEach(refreshLink);}
  function onIntent(event){
    const target=event.target&&event.target.nodeType===3?event.target.parentElement:event.target;
    const link=target&&target.closest?target.closest('a[href]'):null;
    if(link)refreshLink(link);
  }
  w.P4HAttribution={version:2,current:current,decorate:decorate,refresh:refresh,refreshLink:refreshLink,facebookCookie:facebookCookie};
  current();
  ['pointerdown','focusin','contextmenu','click','auxclick'].forEach(type=>d.addEventListener(type,onIntent,true));
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',refresh,{once:true});else refresh();
  w.addEventListener('pageshow',refresh);
})(window,document);


(function(){
 'use strict';
 function init(root){
 if(!root||root.dataset.initialized)return;
 root.dataset.initialized='true';
 const video=root.querySelector('video'),film=root.querySelector('figure'),link=root.querySelector('a'),label=root.querySelector('.p4h-entry-cta-label'),status=root.querySelector('[role="status"]');
 const reduced=matchMedia('(prefers-reduced-motion: reduce)'),connection=navigator.connection;
 let visible=true,away=false,disposed=false,pending=false,failed=false,blocked=false,exitTimer=0;
 const events=[];
 function on(target,type,fn,options){target.addEventListener(type,fn,options);events.push(()=>target.removeEventListener(type,fn,options));}
 function width(){if(!disposed)root.style.setProperty('--p4h-entry-width',document.documentElement.clientWidth+'px');}
 function active(){return !disposed&&!away&&visible&&!document.hidden&&!reduced.matches&&!(connection&&connection.saveData);}
 video.muted=true;video.defaultMuted=true;
 function sync(){
   const run=active();root.toggleAttribute('data-motion',run);
   if(!run){video.pause();return;}
   if(failed||blocked||!video.dataset.src)return;
   if(!video.getAttribute('src')){video.src=video.dataset.src;video.preload='auto';video.load();}
   if(video.paused&&!pending){
     pending=true;
     const play=video.play();
     if(play&&play.then)play.then(()=>{pending=false;if(!active())video.pause();}).catch(error=>{pending=false;if(error.name!=='AbortError')blocked=true;});
     else pending=false;
   }
 }
 function reset(){clearTimeout(exitTimer);link.removeAttribute('data-busy');link.removeAttribute('aria-busy');label.textContent='Acceder a la academia';status.textContent='';}
 on(video,'playing',()=>{if(!active()){video.pause();return;}film.setAttribute('data-ready','');});
 on(video,'error',()=>{failed=true;film.removeAttribute('data-ready');});
 on(video,'pause',()=>{if(active()&&!blocked&&!failed)requestAnimationFrame(sync);});
 on(document,'visibilitychange',sync);
 on(window,'pagehide',()=>{away=true;sync();});
 on(window,'pageshow',()=>{away=false;reset();width();sync();});
 on(window,'resize',width,{passive:true});
 on(reduced,'change',sync);
 if(connection&&connection.addEventListener)on(connection,'change',sync);
 function gesture(){if(blocked&&!failed){blocked=false;sync();}}
 on(root,'pointerdown',gesture,{passive:true});on(root,'keydown',gesture);
 on(link,'click',event=>{
   if(event.defaultPrevented||event.button!==0||event.ctrlKey||event.metaKey||event.altKey||event.shiftKey)return;
   link.setAttribute('data-busy','');link.setAttribute('aria-busy','true');label.textContent='Abriendo academia…';status.textContent='Abriendo P4HBionics Academy.';
   exitTimer=setTimeout(reset,8000);
 });
 const observer='IntersectionObserver'in window?new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:0}):null;
 if(observer)observer.observe(root);
 function cleanup(event){
   if(!event.target.contains(root))return;
   disposed=true;clearTimeout(exitTimer);video.pause();if(observer)observer.disconnect();events.forEach(remove=>remove());
 }
 on(document,'shopify:section:unload',cleanup);
 if(window.P4HAttribution&&window.P4HAttribution.refresh)window.P4HAttribution.refresh();
 width();sync();
 }
 function boot(){init(document.getElementById('p4h-entry-v1'));}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
 document.addEventListener('shopify:section:load',event=>{
   const root=event.target.querySelector('#p4h-entry-v1');
   if(root)init(root);
 });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p4h-homepage"]) return;
  try {
    
(function () {
  'use strict';
  if (window.P4HHomepage && typeof window.P4HHomepage.destroy === 'function') window.P4HHomepage.destroy();
  const instances = new Map();
  let destroyed = false;

  function mount(homepageRoot) {
    if (destroyed || !homepageRoot || !homepageRoot.isConnected) return;
    if (instances.has(homepageRoot)) instances.get(homepageRoot)();
    let disposed = false;
    const cleanups = [];
    const listeners = [];
    const timeouts = new Set();
    const frames = new Set();
    const observers = new Set();
    const videos = Array.from(homepageRoot.querySelectorAll('video')).map(video => ({
      video,
      source: video.getAttribute('src'),
      lazy: video.getAttribute('data-src'),
      motion: video.getAttribute('data-motion-src')
    }));
    const onCleanup = callback => cleanups.push(callback);
    function listen(target, type, listener, options) {
      if (disposed || !target) return;
      target.addEventListener(type, listener, options);
      listeners.push(() => target.removeEventListener(type, listener, options));
    }
    function listenLegacy(target, listener) {
      if (disposed) return;
      target.addListener(listener);
      listeners.push(() => target.removeListener(listener));
    }
    function setTimeout(callback, delay) {
      if (disposed) return 0;
      const id = window.setTimeout(() => { timeouts.delete(id); if (!disposed) callback(); }, delay);
      timeouts.add(id);
      return id;
    }
    function clearTimeout(id) { window.clearTimeout(id); timeouts.delete(id); }
    function requestAnimationFrame(callback) {
      if (disposed) return 0;
      const id = window.requestAnimationFrame(time => { frames.delete(id); if (!disposed) callback(time); });
      frames.add(id);
      return id;
    }
    function IntersectionObserver(callback, options) {
      const observer = new window.IntersectionObserver((entries, instance) => { if (!disposed) callback(entries, instance); }, options);
      observers.add(observer);
      return observer;
    }
    function MutationObserver(callback) {
      const observer = new window.MutationObserver((records, instance) => { if (!disposed) callback(records, instance); });
      observers.add(observer);
      return observer;
    }
    function playVideo(video) {
      if (disposed) return Promise.reject(new DOMException('Section unloaded', 'AbortError'));
      const result = video.play();
      if (!result || typeof result.then !== 'function') return result;
      return result.then(value => {
        if (disposed) { if (!instances.has(homepageRoot)) video.pause(); throw new DOMException('Section unloaded', 'AbortError'); }
        return value;
      });
    }
    function cleanup() {
      if (disposed) return;
      disposed = true;
      listeners.splice(0).forEach(remove => remove());
      observers.forEach(observer => observer.disconnect());
      observers.clear();
      timeouts.forEach(id => window.clearTimeout(id));
      timeouts.clear();
      frames.forEach(id => window.cancelAnimationFrame(id));
      frames.clear();
      cleanups.splice(0).forEach(callback => callback());
      videos.forEach(record => {
        record.video.pause();
        if (record.lazy !== null) record.video.setAttribute('data-src', record.lazy);
        if (record.motion !== null) record.video.setAttribute('data-motion-src', record.motion);
        if (record.lazy !== null || record.motion !== null) {
          if (record.source === null) record.video.removeAttribute('src');
          else record.video.setAttribute('src', record.source);
          record.video.load();
        }
        if (record.video.parentElement) record.video.parentElement.removeAttribute('data-motion-ready');
      });
      const loader = homepageRoot.querySelector('#ph-platform-loader');
      if (loader) { loader.hidden = true; delete loader.dataset.exiting; }
      ['platformInit', 'ready', 'universalFeedback', 'cardMotion', 'enhanced'].forEach(key => { delete homepageRoot.dataset[key]; });
      instances.delete(homepageRoot);
    }
    instances.set(homepageRoot, cleanup);
    try {
(function(){
 'use strict';
 const root=homepageRoot;
 const loader=homepageRoot.querySelector('#ph-platform-loader');
 if(!root||!loader||root.dataset.platformInit==='true')return;
 root.dataset.platformInit='true';
 const started=Date.now();
 let finished=false,hideTimer=0,finishTimer=0;
 loader.hidden=false;
 function dismiss(immediate){
  if(finished){if(immediate)loader.hidden=true;return;}
  finished=true;
  clearTimeout(safetyTimer);
  clearTimeout(finishTimer);
  if(immediate){loader.hidden=true;return;}
  loader.dataset.exiting='true';
  hideTimer=setTimeout(()=>{loader.hidden=true;},220);
 }
 const safetyTimer=setTimeout(()=>dismiss(true),8000);
 function ready(){
  if(finished)return;
  finishTimer=setTimeout(()=>{requestAnimationFrame(()=>requestAnimationFrame(()=>dismiss(false)));},Math.max(0,300-(Date.now()-started)));
 }
 if(document.readyState==='loading')listen(document,'DOMContentLoaded',ready,{once:true});
 else ready();
 listen(window,'pageshow',event=>{if(event.persisted){clearTimeout(hideTimer);dismiss(true);}});
})();

(function(){
 'use strict';
 const root=homepageRoot;
 if(!root||root.dataset.ready==='true')return;
 root.dataset.ready='true';
 const q=s=>root.querySelector(s),qa=s=>Array.from(root.querySelectorAll(s));
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 const hover=window.matchMedia('(hover: hover) and (pointer: fine)');
 const menu=q('#ph-menu-toggle'),nav=q('#ph-navigation');
 function closeMenu(){menu.setAttribute('aria-expanded','false');menu.setAttribute('aria-label','Abrir menú');nav.dataset.open='false';}
 listen(menu,'click',function(){const open=this.getAttribute('aria-expanded')!=='true';this.setAttribute('aria-expanded',String(open));this.setAttribute('aria-label',open?'Cerrar menú':'Abrir menú');nav.dataset.open=String(open);});
 listen(root,'keydown',e=>{if(e.key==='Escape'){closeMenu();}});
 qa('a[href^="#"]').forEach(a=>listen(a,'click',e=>{const id=a.getAttribute('href');if(id.length<2)return;const target=q(id);if(target){e.preventDefault();closeMenu();target.scrollIntoView({behavior:reduced.matches?'auto':'smooth',block:'start'});if(id==='#ph-main')target.focus({preventScroll:true});}}));
 const filterButtons=qa('[data-filter]'),cards=qa('.ph-course');
 filterButtons.forEach(button=>listen(button,'click',()=>{const f=button.dataset.filter;filterButtons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));let visible=0;cards.forEach(c=>{const show=f==='all'||c.dataset.categories.split(' ').includes(f);c.hidden=!show;if(show){visible++;c.classList.add('ph-in');}});q('#ph-course-count').textContent=visible+' curso'+(visible===1?'':'s')+' destacado'+(visible===1?'':'s');}));
 const tabs=qa('[role="tab"]');
 function activateTab(tab,focus){tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;q('#'+t.getAttribute('aria-controls')).hidden=!active;});if(focus)tab.focus();}
 tabs.forEach((tab,index)=>{listen(tab,'click',()=>activateTab(tab,false));listen(tab,'keydown',e=>{let n=index;if(e.key==='ArrowDown'||e.key==='ArrowRight')n=(index+1)%tabs.length;else if(e.key==='ArrowUp'||e.key==='ArrowLeft')n=(index+tabs.length-1)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();activateTab(tabs[n],true);});});
 const video=q('#ph-video'),stage=q('#ph-video-stage'),play=q('#ph-play-toggle'),audio=q('#ph-audio-toggle'),status=q('#ph-video-status');
 let sourceReady=false,userPaused=false,pointerInside=false,manualMode=false,wantsSound=true,playIntent=0;
 video.muted=true;
 function ensureSource(){if(sourceReady)return;video.src=video.dataset.src;video.removeAttribute('data-src');sourceReady=true;video.load();}
 function syncControls(){play.querySelector('span').textContent=video.paused?'Reproducir':'Pausar';play.querySelector('use').setAttribute('href',video.paused?'#ph-play':'#ph-pause');audio.querySelector('span').textContent=video.muted?'Activar sonido':'Silenciar';audio.querySelector('use').setAttribute('href',video.muted?'#ph-mute':'#ph-sound');audio.setAttribute('aria-pressed',String(!video.muted));}
 async function start(withSound,manual){const token=++playIntent;ensureSource();if(manual){userPaused=false;manualMode=true;}video.muted=!withSound;try{await playVideo(video);if(token!==playIntent){if(!manualMode)video.pause();return;}status.textContent=video.muted?'Reproduciendo. Presiona Activar sonido para escuchar la narración.':'Reproduciendo con sonido. Puedes silenciarlo o pausarlo.';}catch(error){if(token!==playIntent)return;if(withSound&&error.name==='NotAllowedError'){video.muted=true;try{await playVideo(video);if(token!==playIntent){if(!manualMode)video.pause();return;}status.textContent='Reproduciendo sin sonido. Presiona Activar sonido para escuchar.';}catch(_){status.textContent='Presiona Reproducir para ver la presentación.';}}else if(error.name!=='AbortError'){status.textContent='Presiona Reproducir para iniciar el video.';}}syncControls();}
 listen(stage,'pointerenter',()=>{pointerInside=true;if(hover.matches&&!reduced.matches&&!userPaused&&!manualMode)start(wantsSound,false);});
 listen(stage,'pointerleave',()=>{pointerInside=false;if(hover.matches&&!manualMode){playIntent++;video.pause();status.textContent='Pasa el cursor sobre el video para continuar.';syncControls();}});
 listen(play,'click',()=>{if(video.paused)start(wantsSound,true);else{userPaused=true;manualMode=false;playIntent++;video.pause();status.textContent='Video en pausa. Presiona Reproducir para continuar.';syncControls();}});
 listen(audio,'click',()=>{wantsSound=video.muted;if(wantsSound){video.muted=false;userPaused=false;start(true,true);}else{video.muted=true;status.textContent='Sonido desactivado.';syncControls();}});
 listen(video,'pointerdown',()=>{manualMode=true;userPaused=false;ensureSource();});
 listen(video,'focus',ensureSource);
 listen(video,'play',()=>{userPaused=false;syncControls();});listen(video,'pause',()=>{if(manualMode)userPaused=true;syncControls();});listen(video,'volumechange',()=>{if(manualMode)wantsSound=!video.muted;syncControls();});
 listen(video,'ended',()=>{manualMode=false;userPaused=true;status.textContent='Presentación finalizada. Explora los cursos o elige tu suscripción.';syncControls();});
 listen(video,'error',()=>{status.textContent='No se pudo cargar el video. Puedes consultar el catálogo o pedir orientación por WhatsApp.';syncControls();});
 listen(document,'visibilitychange',()=>{if(document.hidden){playIntent++;video.pause();syncControls();}});
 if('IntersectionObserver'in window){const visibility=new IntersectionObserver(entries=>{entries.forEach(e=>{if(!e.isIntersecting||e.intersectionRatio<.55){playIntent++;video.pause();syncControls();}else if(!hover.matches&&!reduced.matches&&!userPaused&&!manualMode){start(false,false);}});},{threshold:.55});visibility.observe(stage);
 const reveal=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('ph-in');reveal.unobserve(e.target);}});},{threshold:.08});qa('.ph-reveal').forEach(e=>reveal.observe(e));if(!reduced.matches)root.dataset.enhanced='true';}
 if(!hover.matches)status.textContent='Presiona Reproducir o Activar sonido para escuchar la presentación.';
 if(reduced.matches)status.textContent='Presiona Reproducir para ver la presentación.';
 listen(window,'resize',()=>{if(window.innerWidth>940)closeMenu();});
 q('#ph-year').textContent=String(new Date().getFullYear());
 syncControls();
})();

(function(){
 'use strict';
 const root=homepageRoot;
 if(!root||root.dataset.universalFeedback==='true')return;
 root.dataset.universalFeedback='true';
 let status=root.querySelector('#ph-course-navigation-status')||root.querySelector('#ph-universal-feedback-status');
 if(!status){
  status=document.createElement('p');
  status.id='ph-universal-feedback-status';
  status.className='ph-course-status';
  status.setAttribute('role','status');
  status.setAttribute('aria-live','polite');
  status.setAttribute('aria-atomic','true');
  root.appendChild(status);
 }
 let pending=null,statusOwner=null;
 const brief=new Map();
 const read=(el,name)=>el.getAttribute(name);
 function restore(el,name,value){if(value===null)el.removeAttribute(name);else el.setAttribute(name,value);}
 function announce(message,owner,visible){
  statusOwner=owner;
  status.textContent=message;
  if(visible)status.setAttribute('data-visible','true');else status.removeAttribute('data-visible');
 }
 function clearAnnouncement(owner){
  if(statusOwner!==owner)return;
  statusOwner=null;status.textContent='';status.removeAttribute('data-visible');
 }
 function mark(control,kind){
  const saved={control,feedback:read(control,'data-ph-feedback'),host:read(control,'data-ph-feedback-host'),busy:read(control,'aria-busy')};
  const position=window.getComputedStyle?window.getComputedStyle(control).position:'';
  if(position==='static')control.setAttribute('data-ph-feedback-host','');
  control.setAttribute('data-ph-feedback',kind);
  control.setAttribute('aria-busy','true');
  return saved;
 }
 function unmark(saved){
  restore(saved.control,'data-ph-feedback',saved.feedback);
  restore(saved.control,'data-ph-feedback-host',saved.host);
  restore(saved.control,'aria-busy',saved.busy);
 }
 function cancelBrief(control){
  const state=brief.get(control);
  if(!state)return;
  clearTimeout(state.timer);unmark(state.visual);brief.delete(control);clearAnnouncement(state);
 }

 function temporaryText(container,value){
  const nodes=[];
  function collect(node){
   Array.from(node.childNodes||[]).forEach(child=>{
    if(child.nodeType===3)nodes.push({node:child,value:child.nodeValue});
    else if(child.nodeType===1&&!/^(svg|script|style)$/i.test(child.tagName||''))collect(child);
   });
  }
  collect(container);
  let chosen=nodes.find(item=>item.node.parentNode===container&&item.value.trim())||nodes.find(item=>item.value.trim());
  let added=null;
  if(!chosen){added=document.createTextNode(value);container.appendChild(added);}
  nodes.forEach(item=>{item.node.nodeValue=item===chosen?value:'';});
  return ()=>{nodes.forEach(item=>{item.node.nodeValue=item.value;});if(added&&added.parentNode)added.parentNode.removeChild(added);};
 }
 function courseFeedback(control){
  if(!control.matches('.ph-course-main,.ph-course-open'))return null;
  const card=control.closest('.ph-course');
  const more=card&&card.querySelector('.ph-course-more');
  const label=card&&card.querySelector('.ph-open-label');
  if(!card||!more||!label)return null;
  const hadClass=card.classList.contains('is-loading'),busy=read(card,'aria-busy');
  const restoreMore=temporaryText(more,'Abriendo temario…');
  const restoreLabel=temporaryText(label,'Abriendo…');
  const spinner=document.createElement('span');spinner.className='ph-spinner';spinner.setAttribute('aria-hidden','true');
  more.insertBefore(spinner,more.firstChild);
  card.classList.add('is-loading');card.setAttribute('aria-busy','true');
  const title=card.querySelector('h3');
  return {title:title?title.textContent.trim():'este curso',clear(){
   restoreMore();restoreLabel();if(spinner.parentNode)spinner.parentNode.removeChild(spinner);
   if(!hadClass)card.classList.remove('is-loading');restore(card,'aria-busy',busy);
  }};
 }
 function clearPending(){
  if(!pending)return;
  const state=pending;pending=null;
  clearTimeout(state.timer);if(state.course)state.course.clear();unmark(state.visual);clearAnnouncement(state);
 }
 function resetAll(){
  clearPending();Array.from(brief.keys()).forEach(cancelBrief);
  statusOwner=null;status.textContent='';status.removeAttribute('data-visible');
 }
 function shortFeedback(control,duration,message){
  if(pending&&pending.control===control)clearPending();
  cancelBrief(control);
  const state={visual:mark(control,'generic'),timer:0};
  brief.set(control,state);
  if(message)announce(message,state,false);
  else if(status.hasAttribute('data-visible'))clearAnnouncement(statusOwner);
  state.timer=setTimeout(()=>{if(brief.get(control)===state)cancelBrief(control);},duration);
 }
 function classify(control){
  if(control.tagName.toLowerCase()!=='a')return {kind:'immediate'};
  const raw=(read(control,'href')||'').trim();
  if(!raw||raw.charAt(0)==='#')return {kind:'immediate'};
  let url;
  try{url=new URL(raw,document.baseURI||window.location.href);}catch(_){return {kind:'brief',message:'Solicitando apertura del enlace.'};}
  const target=(read(control,'target')||'').toLowerCase();
  if(control.hasAttribute('download'))return {kind:'brief',message:'Solicitando la descarga.'};
  if(url.protocol==='mailto:')return {kind:'brief',message:'Solicitando apertura del correo.'};
  if(url.protocol==='tel:')return {kind:'brief',message:'Solicitando apertura de llamada.'};
  if(url.hostname==='wa.me'||/(^|\.)whatsapp\.com$/i.test(url.hostname)||url.protocol==='whatsapp:')return {kind:'brief',message:'Solicitando apertura de WhatsApp.'};
  if(url.protocol==='javascript:')return {kind:'immediate'};
  if(!/^https?:$/.test(url.protocol)||target&&!['_self','_top','_parent'].includes(target))return {kind:'brief',message:'Solicitando apertura del enlace.'};
  try{
   const current=new URL(document.baseURI||window.location.href);
   if(url.hash&&url.origin===current.origin&&url.pathname===current.pathname&&url.search===current.search)return {kind:'immediate'};
  }catch(_){}
  return {kind:'navigation',key:url.href+'|'+(target||'_self')};
 }
 listen(root,'click',event=>{

  if(typeof event.button==='number'&&event.button!==0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
  let target=event.target;if(target&&target.nodeType===3)target=target.parentElement;
  const control=target&&target.closest?target.closest('a[href],button,summary'):null;
  if(!control||!root.contains(control)||control.disabled||control.matches(':disabled')||control.closest('[inert],[aria-disabled="true"]'))return;
  const action=classify(control);

  if(action.kind==='immediate'){
   shortFeedback(control,650,'');return;
  }

  if(event.defaultPrevented){shortFeedback(control,650,'');return;}
  if(action.kind==='brief'){
   shortFeedback(control,1200,action.message);return;
  }
  if(pending&&pending.key===action.key){event.preventDefault();return;}
  clearPending();cancelBrief(control);
  const course=courseFeedback(control);
  const state={control,key:action.key,course,visual:mark(control,course?'course':'generic'),timer:0};
  pending=state;
  const label=(read(control,'aria-label')||control.textContent||'el enlace').replace(/\s+/g,' ').trim().slice(0,120);
  announce(course?'Abriendo el temario de '+course.title+'.':'Abriendo '+label+'.',state,false);
  state.timer=setTimeout(()=>{
   if(pending!==state)return;
   clearPending();
   announce('La página está tardando en abrir. Puedes volver a pulsar el enlace para reintentar.',{},true);
  },15000);

 });
 onCleanup(resetAll);
 listen(window,'pagehide',resetAll);
 listen(window,'pageshow',resetAll);
})();

(function(){
 'use strict';
 const root=homepageRoot;
 if(!root||root.dataset.cardMotion==='true')return;
 const grid=root.querySelector('#ph-course-grid');
 const toggle=root.querySelector('#ph-motion-toggle');
 const videos=Array.from(root.querySelectorAll('.ph-model-motion video'));
 if(!grid||!toggle||!videos.length)return;
 root.dataset.cardMotion='true';
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 const connection=navigator.connection||navigator.mozConnection||navigator.webkitConnection;
 let paused=false,explicitPlay=false,frame=0;
 const records=videos.map(video=>({video,stage:video.parentElement,card:video.closest('.ph-course'),visible:false,ratio:0,loaded:false,failed:false,ticket:0,trying:false,wanted:false}));
 records.forEach(record=>{
  const video=record.video;
  video.muted=true;video.defaultMuted=true;
  listen(video,'playing',()=>{
   if(!record.wanted||!record.visible||record.card.hidden||paused||document.hidden||reduced.matches){video.pause();return;}
   record.stage.setAttribute('data-motion-ready','');
  });
  listen(video,'error',()=>{record.failed=true;record.stage.removeAttribute('data-motion-ready');video.pause();schedule();});
 });
 function stop(record){record.wanted=false;record.ticket++;record.trying=false;record.video.pause();}
 function start(record){
  record.wanted=true;
  if(record.failed||record.trying||!record.video.paused)return;
  if(!record.loaded){
   const src=record.video.getAttribute('data-motion-src');
   if(!src)return;
   record.video.src=src;
   record.video.removeAttribute('data-motion-src');
   record.loaded=true;
  }
  const ticket=++record.ticket;
  record.trying=true;
  const promise=playVideo(record.video);
  if(promise&&typeof promise.then==='function')promise.then(()=>{
   if(ticket!==record.ticket)return;
   record.trying=false;
  }).catch(()=>{
   if(ticket!==record.ticket)return;
   record.trying=false;
   record.stage.removeAttribute('data-motion-ready');
  });
  else record.trying=false;
 }
 function sync(){
  frame=0;
  const dataSaver=!!(connection&&connection.saveData&&!explicitPlay);
  const allowed=!paused&&!document.hidden&&!reduced.matches&&!dataSaver;

  const active=allowed?records.filter(r=>r.visible&&!r.card.hidden&&!r.failed).sort((a,b)=>b.ratio-a.ratio).slice(0,4):[];
  records.forEach(record=>{if(active.includes(record))start(record);else stop(record);});
  toggle.hidden=reduced.matches;
  const userPaused=paused||dataSaver;
  toggle.setAttribute('aria-pressed',String(userPaused));
  toggle.setAttribute('aria-label',userPaused?'Reproducir animaciones de los modelos':'Pausar animaciones de los modelos');
  toggle.querySelector('span').textContent=userPaused?'Reproducir animaciones':'Pausar animaciones';
 }
 function schedule(){if(!frame)frame=requestAnimationFrame(sync);}
 listen(toggle,'click',()=>{
  if(connection&&connection.saveData&&!explicitPlay){explicitPlay=true;paused=false;}
  else paused=!paused;
  sync();
 });
 if('IntersectionObserver' in window){
  const observer=new IntersectionObserver(entries=>{
   entries.forEach(entry=>{const record=records.find(r=>r.stage===entry.target);if(record){record.visible=entry.isIntersecting&&entry.intersectionRatio>=.12;record.ratio=entry.intersectionRatio;}});
   schedule();
  },{rootMargin:'0px',threshold:[0,.12,.35,.6,.85,1]});
  records.forEach(record=>observer.observe(record.stage));
 }else{

  toggle.hidden=true;return;
 }
 if('MutationObserver' in window)new MutationObserver(schedule).observe(grid,{attributes:true,subtree:true,attributeFilter:['hidden']});
 listen(document,'visibilitychange',sync);
 onCleanup(()=>records.forEach(stop));
 listen(window,'pagehide',()=>records.forEach(stop));
 listen(window,'pageshow',schedule);
 if(reduced.addEventListener)listen(reduced,'change',sync);else if(reduced.addListener)listenLegacy(reduced,sync);
 if(connection&&connection.addEventListener)listen(connection,'change',sync);
 sync();
})();
    } catch (error) {
      cleanup();
      throw error;
    }
  }
  function rootsIn(scope) {
    const roots = [];
    if (scope.nodeType === 1 && scope.matches('#p4h-home')) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll('#p4h-home'));
    return roots;
  }
  function mountIn(scope) { rootsIn(scope).forEach(mount); }
  function ready() { mountIn(document); }
  function load(event) { mountIn(event.target); }
  function unload(event) {
    Array.from(instances).forEach(([root, cleanup]) => {
      if (event.target === root || (event.target.contains && event.target.contains(root))) cleanup();
    });
  }
  function destroy() {
    if (destroyed) return;
    destroyed = true;
    document.removeEventListener('DOMContentLoaded', ready);
    document.removeEventListener('shopify:section:load', load);
    document.removeEventListener('shopify:section:unload', unload);
    Array.from(instances.values()).forEach(cleanup => cleanup());
  }
  window.P4HHomepage = { mount, destroy };
  document.addEventListener('shopify:section:load', load);
  document.addEventListener('shopify:section:unload', unload);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})();

  } catch(e) { console.error(e); }
})();
})();
